<template>
  <div class="mg-good-things" mg-stat-show="flag=610" mg-stat-lob="smod=newyear_gift">
    <p class="module-title">{{ info.name }}</p>
    <span class="more" @click="clickJumpNav('https://app.mgtv.com/credits/mall.html?lastp=credits&isV2=1', '5009')">查看更多</span>
    <div
      class="gift-wrap"
    >
      <div
        v-for="(item, index) in info.list"
        :key="index"
        class="gift"
        @click="clickJumpNav(item, '5036', item.goods_id)"
      >
        <a href="javascript:;" class="img-wrap">
          <img :src="item.original_img" alt="">
        </a>
        <p class="item-black-title">{{ item.goods_name }}</p>
        <p class="gift-info">
          <span class="num">{{ item.exchange_integral }}</span>积分<span v-if="Number(item.exchange_price) > 0"><span class="plus">+</span><span class="num">{{ parseFloat(item.exchange_price) }}</span>元</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { loginMixin } from '@/utils/mixin'
import { jumpPage, getHaoWuUrl } from '@/utils/mUtil'

export default {
  mixins: [loginMixin],
  props: {
    info: {
      type: Object,
      default: null,
    },
  },
  methods: {
    clickJumpNav(url, evt, id) {
      MgStat.send(
        'click',
        {
        },
        {
          cntp: 'score_newHome',
          mod: 'newyear_gift',
          cont: this.info.name,
        }
      )

      if (id) {
        location.href = getHaoWuUrl(id, '', 'credits')
      } else {
        jumpPage(url)
      }
    },
  },
  computed: {
    proids() {
      return this.info.list.map(v => v.goods_id).join('#')
    },
  },
  name: 'MgGoodThings',
  components: {},
}
</script>
<style scoped lang="less">
.mg-good-things {
  background: #FFFFFF;
  border-radius: 36px 36px 36px 36px;
  padding: 34px 22px 24px 26px;
  position: relative;
  text-align: left;
  .module-title {
    // font-family: AlimamaFangYuanTiVF-Thin;
    font-weight: 600;
    margin-bottom: 24px;
    margin-left: 12px;
  }
  .more {
    position: absolute;
    top: 39px;
    right: 34px;
    color: rgba(0, 0, 0, 0.2);
    font-weight: 500;
    font-size: 24px;
    &::after {
      content: '';
      display: inline-block;
      width: 13px;
      height: 13px;
      border: 3px solid rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      position: relative;
      // top: 2px;
      transform: rotateZ(-45deg);
      border-left-color: transparent;
      border-top-color: transparent;
    }
  }

  .gift-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .gift {
    margin-bottom: 34px;
    &:nth-last-child(-n+3) {
      margin-bottom: 0;
    }
    // &:nth-child(n + 4) {
    //   margin-top: 20px;
    // }

    .img-wrap {
      position: relative;
      display: block;
      width: 303px;
      height: 303px;
      border-radius: 36px;
      // background-image: url('../../../assets/bg-goods.png');
      background-size: 100% 100%;
      // border: 1px dashed #eee;
      margin-bottom: 18px;
      overflow: hidden;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        max-width: 98%;
        max-height: 98%;
        object-fit: cover;
      }
    }

    .item-black-title {
      padding-left: 12px;
      width: 275px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .gift-info {
      padding-left: 12px;
      font-weight: 400;
      font-size: 22px;
      color: rgba(0, 0, 0, 0.4);
      .plus {
        margin: 0 6px;
      }
      .num {
        font-family: DIN Alternate, DIN Alternate;
        font-weight: bold;
        font-size: 28px;
        color: #FF4500;
        margin-right: 6px;
      }
    }
  }
}
</style>
